// App.js
import React from 'react';
import './App.css';
import Desarrolladores from './Desarrolladores';

function App() {
  return (
    <div className="App">
      <Desarrolladores />
    </div>
  );
}

export default App;